import { forwardRef } from 'react';
import { useMapTokenPropsToCSS } from '../../hooks/useMapTokenPropsToCSS';
import { filterProps } from '../filterProps';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * HOC to provide the useMapTokenPropsToCSS hook to a class component
 * with the transient prop still intact.
 * Created to pass to styled-components wrapped by other HOC.
 * @param WrappedComponent - The component to provide token props support to.
 * @returns A new component that has $cssStyles prop support.
 */
export function withCssStyles(WrappedComponent) {
  const displayName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
  const ComponentWithTokenProps = /*#__PURE__*/forwardRef((props, ref) => {
    const {
      tokenProps
    } = filterProps(props);
    const cssProps = useMapTokenPropsToCSS(tokenProps);
    const componentProps = Object.assign({}, props, {
      $cssStyles: cssProps,
      ref
    });
    return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, componentProps));
  });
  ComponentWithTokenProps.displayName = `withTokenProps(${displayName})`;
  return ComponentWithTokenProps;
}